/**
 * Applies config.settings to CSS custom properties on the runtime's root
 * element. Step modules read these via `var(--quiz-primary)` etc. — no
 * theme threading through props.
 */

import type { RuntimeSettings } from '@/types/runtime';

export function applyTheme(root: HTMLElement, settings: RuntimeSettings): void {
  // CSS custom-property assignment via .style.setProperty is safe — the
  // CSSOM parses the value and silently ignores invalid input, so even a
  // hostile string can't escape into adjacent properties.
  root.style.setProperty('--quiz-primary', settings.primaryColor);
  // Buttons key off --quiz-button so publishers can recolor them independently
  // of the primary accent. Empty buttonColor → inherit the primary color.
  root.style.setProperty('--quiz-button', settings.buttonColor?.trim() || settings.primaryColor);
  root.style.setProperty('--quiz-bg', settings.backgroundColor);
  root.style.background = settings.backgroundColor;
}
